<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('knowUs.title')}}</h1>
      </div>
    </div>
    <div v-for="i in Math.ceil((knownUsList.length)/nbColumn)" :key="i" class="row listOfButtons">
      <div v-for="(item, index) in knownUsList.slice((i-1)*nbColumn, (i-1)*nbColumn+nbColumn)" :key="index" class="col">
        <button :class="'btn btn-secondary ' + ((selectedIndex === (i-1)*nbColumn+index) ? 'bg-color' : '')" @click="selectedIndex =((i-1)*nbColumn+index)">{{i18nList[item]}}</button>
      </div>
    </div>
    <div class="row"><div class="col"><p class="questionLabel">{{$t('knowUs.wishTime.question')}}</p></div></div>
    <div class="row listOfButtons">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((wish == 'less1month') ? 'bg-color' : '')" @click="wish='less1month'">{{$t('knowUs.wishTime.less1month')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((wish == '6monthsTo1year') ? 'bg-color' : '')" @click="wish='6monthsTo1year'">{{$t('knowUs.wishTime.6monthsTo1year')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((wish == '2yearsormore') ? 'bg-color' : '')" @click="wish='2yearsormore'">{{$t('knowUs.wishTime.2yearsormore')}}</button>
      </div>
    </div>
    <div class="row">
      <div class="col overFooter">
        <button type="submit" :class="'btn btn-primary alignRight ' + ((wish !== '' && selectedIndex != null) ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'knowus',
  data () {
    return {
      nbColumn: 3,
      selectedIndex: null,
      wish: '',
      i18nList: {
        promo: this.$t('knowUs.promo'),
        walkIn: this.$t('knowUs.walkIn'),
        advertising: this.$t('knowUs.advertising'),
        sponsor: this.$t('knowUs.sponsor'),
        internet: this.$t('knowUs.internet'),
        flyers: this.$t('knowUs.flyers'),
        pubtruck: this.$t('knowUs.pubtruck'),
        oldmember: this.$t('knowUs.oldmember'),
        kakemono: this.$t('knowUs.kakemono'),
        other: this.$t('knowUs.other')
      }
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'KnowUs', isAuthorized: (this.$store.getters['user/isAuthenticated'] && this.$store.getters['config/isConfigOk'] && this.selectedIndex != null && this.wish !== ''), data: this.dataTosave});
  },
  methods: {
    saveData: function (index) {
      if (this.$store.getters['user/isAuthenticated'] && this.$store.getters['config/isConfigOk'] && this.wish !== '' && this.selectedIndex != null) {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
      } else if (!this.$store.getters['config/isConfigOk']) {
        this.$store.dispatch('config/CONFIG_TOGGLECONFIGMODE');
      }
    }
  },
  computed: {
    dataTosave: function () {
      return {
        knowUs: {
          who: this.knownUsList[this.selectedIndex],
          fitnessWish: this.wish
        }
      };
    },
    knownUsList: function () {
      return this.$store.state.config.knowus;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/KnowUs.vue